import { useState } from "react";
import SVG from "../../../Components/SVG";
import Divider from "../../SignIn/Components/Divider";
import GradientBlue from "../../../Components/InputFields/GradientBlue";

export default function VerificationModalGuide({ onNext, data, onClose }) {
  const [copied, setCopied] = useState(false);

  function handleCopy() {
    navigator.clipboard.writeText(data?.secret || "").then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  }

  return (
    <div className="w-full max-h-[85dvh] rounded-2xl p-5 flex flex-col gap-5 drop-shadow-lg bg-zi-bg2-light dark:bg-zi-bg2-dark">
      <div className="w-full flex items-start justify-between gap-3 mb-5">
      <h3 className="font-medium text-xl text-zi-text-light dark:text-zi-text-dark">
        آموزش افزودن تأیید دو مرحله‌ای
      </h3>
      <span onClick={onClose}>
        <SVG name="close" classname="stroke-zi-text-light dark:stroke-zi-text-dark size-5 cursor-pointer" />
      </span>
      </div>

      <div className="flex-1 overflow-y-auto">
      <div className="w-full flex flex-col gap-5">
        <p className="font-normal text-base text-zi-text-light dark:text-zi-text-dark">
          کد زیر را در برنامه Google Authenticator وارد کنید
        </p>
        <div className="w-full flex items-center justify-end gap-5">
          <button
            type="button"
            onClick={handleCopy}
            className="flex items-center justify-center gap-1 rounded-lg py-1 px-2 bg-zi-bg1-light dark:bg-zi-bg1-dark"
          >
            <SVG
              name="copy"
              classname="opacity-50 stroke-zi-border-dark dark:stroke-zi-border-light"
              style={{}}
            />
            <span className="font-normal whitespace-nowrap text-xs opacity-50 text-zi-text-light dark:text-zi-text-dark">
              {copied ? "کپی شد!" : "کپی کردن"}
            </span>
          </button>
          <span className="w-full overflow-x-auto [direction:ltr] font-medium text-lg text-zi-text-light dark:text-zi-text-dark">
            {data?.secret || ""}
          </span>
        </div>
      </div>

      <Divider text="یا" />

      <div className="w-full flex flex-col gap-5">
        <p className="font-normal text-base text-zi-text-light dark:text-zi-text-dark">
          تصویر زیر را با استفاده از برنامه Google Authenticator اسکن کنید
        </p>

        <div className="self-center size-32 sm:size-48 aspect-square rounded-lg mb-5 bg-zi-bg1-light dark:bg-zi-bg1-dark">
          <img src={data?.qrcode_data_uri || ""} alt="QR code" />
        </div>
      </div>
      </div>

      <GradientBlue type="button" value="بعدی" onClick={onNext} />
    </div>
  );
}
